import axios from "axios";

// Створюємо базовий клієнт
const apiClient = axios.create({
  baseURL: "https://api.nirvana-bot.website", //api-dev | api
  timeout: 90000,
});
// Додаємо Interceptor (перехоплювач запитів)
apiClient.interceptors.request.use(
  (config) => {
    // Дістаємо initData прямо з глобального об'єкта вікна
    const initData = window?.Telegram?.WebApp?.initData;

    if (initData) {
      // НАЙКРАЩА ПРАКТИКА: Передавати initData в заголовках (Headers)
      config.headers.Authorization = `Bearer ${initData}`; // Або tma ${initData}

      // ЯКЩО твій бекенд зараз чекає його в тілі/параметрах (як у твоєму apiGet):
      if (config.method === "get") {
        config.params = { ...config.params, initData };
      } else {
        config.data = { ...config.data, initData };
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export default apiClient;
